import { render, staticRenderFns } from "./layout-list.vue?vue&type=template&id=fedfd3a6&scoped=true&"
import script from "./layout-list.vue?vue&type=script&lang=js&"
export * from "./layout-list.vue?vue&type=script&lang=js&"
import style0 from "./layout-list.vue?vue&type=style&index=0&lang=less&"
import style1 from "./layout-list.vue?vue&type=style&index=1&id=fedfd3a6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fedfd3a6",
  null
  
)

export default component.exports